import { CustomerAction, CustomerActions, CustomerWithdrawals } from '../model';
import { CustomerState, wrapStateWithCustomerNumber } from '../utils/url';
import { ResponsePayload } from '../model/request';

import createReducer from './createReducer';

export const customerWithdrawals = createReducer<CustomerState<CustomerWithdrawals>>({}, {
  [CustomerActions.FETCH_WITHDRAWALS_SUCCESS](
    state: CustomerState<CustomerWithdrawals>,
    action: CustomerAction
  ) {
    return wrapStateWithCustomerNumber((
      action.payload as ResponsePayload<CustomerWithdrawals>
    ).data, state, undefined);
  },
});
